import { IconPlaceholderAgency24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC, type ReactNode } from 'react';

import { AuthorLabel } from '../AuthorLabel';

import styles from './AuthorItem.css';

export interface IAuthorItemProps {
  contactsButton?: ReactNode;
  name: string;
  label?: string | null;
  logoUrl?: string | null;
}

export const AuthorItem: FC<IAuthorItemProps> = ({ contactsButton, name, label, logoUrl }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['info']}>
        <AuthorLabel label={label} logoIcon={<IconPlaceholderAgency24 />} logoUrl={logoUrl} name={name} />
      </div>

      {contactsButton && <div className={styles['button']}>{contactsButton}</div>}
    </div>
  );
};
